import { Injectable, inject } from '@angular/core';
// import { Actions, Effect, ofType } from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import {
	ActionTypes,
	CreateAppointment,
	CreateAppointmentError,
	CreateAppointmentSuccess,
	GetAppointments,
	GetAppointmentsSuccess,
	GetAppointmentsError,
	RescheduleAppointment,
	RescheduleAppointmentSuccess,
	RescheduleAppointmentError,
	CancelAppointment,
	CancelAppointmentSuccess,
	CancelAppointmentError
} from "./appointment.actions";
import { Helper } from "../../shared/services/Helper.service";
import { AppointmentService } from "../../shared/services/appointment.service";
import { MatDialog } from "@angular/material/dialog";
import { AlertPopupService } from "../../shared/services/alert-popup.service";

@Injectable()
export class AppointmentEffects {

	// @Effect()
	// CreateAppointment$ = this.actions$.pipe(
	CreateAppointment$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CreateAppointment),
			map((action: CreateAppointment) => action.payload),
			mergeMap((payload) => {
				return this.appointmentService.doRegister(payload).pipe(
					map((response) => {
						return new CreateAppointmentSuccess(response)
					}),
					catchError((error) => of(new CreateAppointmentError(error))))
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CreateAppointmentSuccess$ = this.actions$.pipe(
	CreateAppointmentSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CreateAppointmentSuccess),
			map((action: CreateAppointmentSuccess) => action.payload),
			mergeMap((payload) => {
				this.dialog.closeAll();
				this.alertPopupService.showInfoAlert('Appointment created successfully');
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CreateAppointmentError$ = this.actions$.pipe(
	CreateAppointmentError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CreateAppointmentError),
			map((action: CreateAppointmentError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// GetAppointments = this.actions$.pipe(
	GetAppointments = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAppointments),
			map((action: GetAppointments) => action.payload),
			mergeMap((payload) => {
				return this.appointmentService.GetAppointments(payload).pipe(
					map((response) => {
						console.log('API Response', response);
						return new GetAppointmentsSuccess(response)
					}),
					catchError((error) => of(new GetAppointmentsError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// GetAppointmentsSuccess$ = this.actions$.pipe(
	GetAppointmentsSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAppointmentsSuccess),
			map((action: GetAppointmentsSuccess) => action.payload),
			mergeMap((payload) => {
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// GetAppointmentsError$ = this.actions$.pipe(
	GetAppointmentsError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.GetAppointmentsError),
			map((action: GetAppointmentsError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// RescheduleAppointment$ = this.actions$.pipe(
	RescheduleAppointment$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.RescheduleAppointment),
			map((action: RescheduleAppointment) => action.payload),
			mergeMap((payload) => {
				return this.appointmentService.rescheduleAppointment(payload.appointmentID, payload.params).pipe(
					map((response) => {
						return new RescheduleAppointmentSuccess(response)
					}),
					catchError((error) => of(new RescheduleAppointmentError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// RescheduleAppointmentSuccess$ = this.actions$.pipe(
	RescheduleAppointmentSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.RescheduleAppointmentSuccess),
			map((action: RescheduleAppointmentSuccess) => action.payload),
			mergeMap((payload) => {
				this.dialog.closeAll();
				this.alertPopupService.showInfoAlert('Appointment Reschedule successfully.');
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// RescheduleAppointmentError$ = this.actions$.pipe(
	RescheduleAppointmentError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.RescheduleAppointmentError),
			map((action: RescheduleAppointmentError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	// @Effect()
	// CancelAppointment$ = this.actions$.pipe(
	CancelAppointment$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CancelAppointment),
			map((action: CancelAppointment) => action.payload),
			mergeMap((payload) => {
				return this.appointmentService.CancelAppoitment(payload.appointmentID, payload.params).pipe(
					map((response) => {
						return new CancelAppointmentSuccess(response)
					}),
					catchError((error) => of(new CancelAppointmentError(error)))
				)
			})
		)
	});
	// );

	// @Effect({ dispatch: false })
	// CancelAppointmentSuccess$ = this.actions$.pipe(
	CancelAppointmentSuccess$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CancelAppointmentSuccess),
			map((action: CancelAppointmentSuccess) => action.payload),
			mergeMap((payload) => {
				this.dialog.closeAll();
				this.alertPopupService.showInfoAlert('Appointment Cancel successfully.');
				return of();
			})
		)
	}, { dispatch: false });
	// );

	// @Effect({ dispatch: false })
	// CancelAppointmentError$ = this.actions$.pipe(
	CancelAppointmentError$ = createEffect(() => {
		return inject(Actions).pipe(
			ofType(ActionTypes.CancelAppointmentError),
			map((action: CancelAppointmentError) => action.payload),
			mergeMap((payload) => {
				this.helper.Error$(payload);
				return of(null)
			})
		)
	}, { dispatch: false });
	// );

	constructor(
		private actions$: Actions,
		private helper: Helper,
		private appointmentService: AppointmentService,
		private dialog: MatDialog,
		private alertPopupService: AlertPopupService,
	) {
	}
}
